import { getOversoldAvailability } from './overbooking';

/**
 * Checks whether the trip is actively selling oversold inventory.
 * @param {object} trip - Search result trip.
 * @returns {boolean}
 */
const hasActiveOverbooking = (trip) => {
  return (
    Number(trip?.availability) === 0 && Number(getOversoldAvailability(trip?.passengerTypes)) > 0
  );
};

/**
 * Checks whether quick purchase must be blocked because the trip is actively
 * selling oversold inventory.
 * @param {object} trip - Search result trip.
 * @returns {boolean}
 */
export const isQuickPurchaseBlockedByOverbooking = (trip) => {
  return hasActiveOverbooking(trip);
};

export default {
  isQuickPurchaseBlockedByOverbooking,
};
